<template>
    <v-select
        :value="value"
        prepend-inner-icon="assignment"
        outlined
        dense
        v-on:input="$emit('input', $event)"
        item-text="name"
        item-value="id"
        menu-props="auto"
        class="soli-round soli-grey"
        :items="rateOptions"
        label="Select Role"
        :disabled="loading || rateOptions.length == 1"
        :menu-props="{
            left: true,
        }"
        :rules="rules"
        hide-details="auto"
        return-object
    />
</template>

<script>
export default {
    props: {
        value: {
            type: Object,
            default: () => {},
        },
        user: {
            type: Object,
            required: true,
        },
        end: {
            type: String,
            default: null,
        },
        rules: {
            type: Array,
            default: () => [],
        },
    },
    data: function () {
        return {
            roles: [],
            showPermissions: false,
            rateOptions: [],
            loading: true,
            selectRate: null,
        };
    },
    methods: {
        fetchPayRates() {
            axios
                .get(`/api/users/pay-rates/${this.user.id}`, {
                    params: {
                        timeClockRates: 1,
                        end: this.end,
                    },
                })
                .then((resp) => {
                    this.rateOptions = resp.data.map((rate) => rate.role);
                    this.loading = false;
                    if (this.rateOptions.length == 1) {
                        this.$emit("input", this.rateOptions[0]);
                    }
                    if (!this.rateOptions.length) {
                        this.$emit("input", null);
                    }
                });
        },
    },
    mounted() {
        this.fetchPayRates();
    },
};
</script>
